var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-3.24249e-05 8.00094C-3.24249e-05 7.70257 0.118494 7.41642 0.329473 7.20544C0.540451 6.99447 0.826599 6.87594 1.12497 6.87594L14.9062 6.87594L10.0762 2.04688C9.86487 1.83553 9.74614 1.54889 9.74614 1.25C9.74614 0.951116 9.86487 0.664472 10.0762 0.453127C10.2876 0.241782 10.5742 0.123049 10.8731 0.123049C11.172 0.123049 11.4586 0.241782 11.67 0.453127L18.42 7.20313C18.5248 7.30764 18.6081 7.43184 18.6648 7.56858C18.7216 7.70533 18.7509 7.85194 18.7509 8C18.7509 8.14807 18.7216 8.29468 18.6648 8.43142C18.6081 8.56817 18.5248 8.69236 18.42 8.79688L11.67 15.5469C11.5653 15.6515 11.4411 15.7345 11.3044 15.7912C11.1676 15.8478 11.0211 15.877 10.8731 15.877C10.7251 15.877 10.5786 15.8478 10.4418 15.7912C10.3051 15.7345 10.1809 15.6515 10.0762 15.5469C9.97157 15.4422 9.88856 15.318 9.83193 15.1813C9.77529 15.0445 9.74614 14.898 9.74614 14.75C9.74614 14.602 9.77529 14.4555 9.83193 14.3187C9.88856 14.182 9.97157 14.0578 10.0762 13.9531L14.9062 9.12594L1.12497 9.12594C0.826599 9.12594 0.540451 9.00741 0.329473 8.79643C0.118494 8.58546 -3.24249e-05 8.29931 -3.24249e-05 8.00094Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/rightArrow.b9bdfb7853745a0dc46f7c8a13079c27.svg";
export { ForwardRef as ReactComponent };